import { Expose } from 'class-transformer';

export class CopyOrderDto {
  @Expose()
  cartId: string;
  @Expose()
  productId: string;
  @Expose()
  variantId?: string | null;
  @Expose()
  code: string;
  @Expose()
  msg: string;
}
